import { type FieldCitations } from '../../../models/Citation'

export type HolderNameSource = 'contact' | 'manual' | null

export type ClientStatus = 'new' | 'existing'

export interface WizardHolder {
  roleCode: string
  nameSource: HolderNameSource
  name: string
  contactId: string | null
  relationship?: string
  clientStatus?: ClientStatus
  externalId?: string
}

export interface ContactOption {
  id: string
  name: string
  firstName?: string
  lastName?: string
  email?: string
  custodianIds?: Record<string, string>
}

export interface WizardAccount {
  accountRefId: string
  selection: Record<string, string>
  typeId: string
  holders: WizardHolder[]
  schemaSnapshot: Record<string, unknown>
  schemaFetchedAt?: string
  values: Record<string, unknown>
  citations?: FieldCitations
}

export const createEmptyAccount = (): WizardAccount => ({
  accountRefId: crypto.randomUUID(),
  selection: {},
  typeId: '',
  holders: [],
  schemaSnapshot: {},
  values: {},
  citations: {},
})

export interface ItemPatch {
  values?: Record<string, unknown>
  holders?: WizardHolder[]
  selection?: Record<string, string>
  typeId?: string
}

export interface WizardParty {
  customerRefId: string
  name: string
  contactId: string | null
  externalId?: string
  custodianDetailsOf?: string
  custodianDetailsAt?: string
  roleCodes: string[]
  kycSchemaSnapshot: Record<string, unknown>
  kycValues: Record<string, unknown>
  citations?: FieldCitations
}

export interface WizardFormContext {
  missingFieldIds: Set<string>
  formData?: Record<string, unknown>
  idPrefix?: string
  citations?: FieldCitations
}

export interface WizardContext {
  accountId: string
  connector: string
  contactId: string | null
  roomId: string | null
  sessionId: string | null
  meetingTemplateId: string | null
}
